<div class="container1 mb-6 scrollable-content" *ngIf="quotes().length > 0">
  <div>
    <button class="btn btn-sm my-1 close-btn" (click)="closeDialog()">
      <i class="bi bi-x-circle"></i>
    </button>
    <div class="quote-container mt-6">
      <h4 class="mb-3">{{ quotes()[0].quoteNo }}</h4>
      <button class="btn btn-sm btn-primary my-1" (click)="setQuoteData()">Select Quote</button>
    </div>
    <div class="quote-container">
        <label></label>
        <label class="form-check-label me-3 text-black d-block text-end">
        <b>Note: If EQBD coverage is required, you must first issue a Quote<br/> with EQBD option. Please close and return to Amend Quote.</b>
      </label>
      </div>
    <hr class="full-width-hr"> 
    <div class="mb-2">
      <div class="row text-center flex-nowrap table-header-row">
        <div class="col-3 fw-bold text-start quote date fixed-column">Quote Date Created</div>
        <div class="col-3 fw-bold text-start quote" *ngFor="let version of quotes(); let i = index">
          <label class="btn btn-outline btn-active-light-primary py-5 px-4 d-flex align-items-center">
            <span class="form-check form-check-custom form-check-solid me-2">
              <input class="form-check-input" type="radio" name="quote" [value]="version.versionNo"
                [checked]="selectedQuote()?.versionNo === version.versionNo" (change)="onQuoteSelect(version)" />
            </span>
            <span class="d-block fw-semibold text-start">
              <span class="text-gray-900 fw-bold d-block fs-7">{{version.quoteNo}} - 0{{ i + 1 }} - <br>{{ version.quoteDate | date:'MM/dd/yyyy' }}</span>
            </span>
          </label>
        </div>
      </div>
      <hr class="full-width-hr"> 
      <div class="">
        <div *ngFor="let addressIndex of getMaxAddressIndex()">
          <div class="location-row row  flex-nowrap">
            <div class="col-3 fw-bold text-start fixed-column">Location #{{ addressIndex + 1 }} Address</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes()"> <ng-container *ngIf="version.addresses[addressIndex]">
                {{ version.addresses[addressIndex].streetNum }},
                {{ version.addresses[addressIndex].streetName }},
                {{ version.addresses[addressIndex].unitNum ? version.addresses[addressIndex].unitNum + "," : " "}}
                {{ version.addresses[addressIndex].city }},<br> {{ version.addresses[addressIndex].county }}, {{ version.addresses[addressIndex].state }},<br>
                {{ version.addresses[addressIndex].zipcode }}
              </ng-container>
            </div>
          </div>
          <div>
          </div>
          <hr class="full-width-hr"> </div>

        <div class=" pb-2"> 
          
          <div class="row text-center  flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Cause of Loss</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes(); let i = index">
              {{ version.causeOfLossDesc }}
            </div>
          </div>
          <div class="row text-center flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">AOP Ded</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes(); let i = index">
              {{ version.aopDeductibleAmount | currency:'USD':'$ ':'1.2-2'}}
            </div>
          </div>
          <div class="row text-center  flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Wind/Hail</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes(); let i = index">
              {{ version.windDeductibleFlag ? "Excluded" : "Included" }}
            </div>
          </div> 
          <div class="row text-center  flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Wind/Hail Deductible</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes(); let i = index">
              {{ version.windDeductibleDescription }}
            </div>
          </div>          
          <div class="row text-center  flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Property Enhancement</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes(); let i = index">
              {{ version.propertyExtCoverageType === 1 ? "Property Enhancement Silver" :
              version.propertyExtCoverageType === 2 ? "Property Enhancement Gold" :
              "No Enhancement Selected" }}
            </div>
          </div>
          <div class="row text-center  flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Water Damage Coverage</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes(); let i = index">
              {{ version.waterDamageDescription }}
            </div>
          </div>
          <div class="row text-center  flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Theft Coverage</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes(); let i = index">
              {{ version.vandalismDescription }}
            </div>
          </div>
          <div class="row text-center  flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Equipment Breakdown</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes(); let i = index">
              {{ version.eqbdFlag === true ? "Coverage Included" : "No Coverage" }}
            </div>
          </div>
          <div class="row text-center flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Total Insured Values</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes(); let i = index">
              {{ version.totalInsuredValue| currency:'USD':'$ ':'1.2-2' }}
            </div>
          </div>
        </div>
        <hr class="full-width-hr"> 
        <div class="pb-2"> 
          <div class="row text-center flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Commercial Property</div>
            <div class="col-3 address-cell currency-cell" [style.color]="updateRagIndicationColor(version.ragIdDescription)" *ngFor="let version of quotes(); let i = index">
              <span class="currency-value">{{ version.targetPremium | currency:'USD':'$ ':'1.2-2' }}</span>
            </div>
          </div>
          <div class="row text-center flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Equipment Breakdown</div>
            <div class="col-3 address-cell currency-cell" *ngFor="let version of quotes(); let i = index">
              <span class="currency-value">{{ version.eqbdPremium | currency:'USD':'$ ':'1.2-2' }}</span>
            </div>
          </div>
          <div class="row text-center flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Inspection fee</div>
            <div class="col-3 address-cell currency-cell" *ngFor="let version of quotes(); let i = index">
              <span class="currency-value">{{ version.inspectionFee | currency:'USD':'$ ':'1.2-2' }}</span>
            </div>
          </div>
          <div class="row text-center flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Policy fee</div>
            <div class="col-3 address-cell currency-cell" *ngFor="let version of quotes()">
              <span class="currency-value">{{ getPolicyFeeForVersion(version) | currency:'USD':'$ ':'1.2-2' }}</span>
            </div>
          </div>
          <div class="row text-center flex-nowrap location-row"> 
            <div class="col-3 fw-bold text-start fixed-column">Surplus Lines Tax</div>
            <div class="col-3 address-cell currency-cell" *ngFor="let version of quotes()">
              <span class="currency-value">{{ getSurplusLinesTaxForVersion(version) | currency:'USD':'$ ':'1.2-2' }}</span>
            </div>
          </div>
          <div class="row text-center flex-nowrap location-row" *ngFor="let feeDesc of getAdditionalFeeDescriptions()">
            <div class="col-3 fw-bold text-start fixed-column">{{ feeDesc }}</div>
            <div class="col-3 address-cell currency-cell" *ngFor="let version of quotes()">
              <span class="currency-value">{{ getAdditionalFeeForVersion(version, feeDesc) | currency:'USD':'$ ':'1.2-2' }}</span>
            </div>
          </div>
          <div class="row text-center flex-nowrap location-row">
            <div class="col-3 fw-bold text-start fixed-column">Total Policy Premium</div>
            <div class="col-3 fw-bold address-cell currency-cell" *ngFor="let version of quotes()">
              <span class="currency-value">{{ getTotalPolicyPremiumForVersion(version) | currency:'USD':'$ ':'1.2-2' }}</span>
            </div>
          </div>
          
        </div>
        <hr class="full-width-hr"> 
        <div class="pb-2"> 
          <div class="row text-center flex-nowrap location-row">
            <div class="col-3 fw-bold text-start fixed-column">Optional Coverage</div>
            <div class="col-3 text-start address-cell" *ngFor="let version of quotes()">
            </div>
          </div>
          <div class="row text-center flex-nowrap location-row">
            <div class="col-3 fw-bold text-start fixed-column">TRIA Premium (Excl Taxes and Fees)</div>
            <div class="col-3 address-cell currency-cell" *ngFor="let version of quotes()">
              <span class="currency-value">{{ version.triaPremium | currency:'USD':'$ ':'1.2-2'}}</span>
            </div>
          </div>
          </div>
          
      </div>
    </div>
  </div>
</div>